import { useEffect, useState } from 'react';

import Page from 'components/Page';
import UsersGrid from 'components/UsersGrid';

import useUsers from 'hooks/useUsers';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const UsersPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { fetchUsers, users = [] } = useUsers();

    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetchUsers().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetchUsers().next();

    return (
        <Page className={styles.usersPage} testId={testId}>
            <UsersGrid onNext={hasMore ? handleNext : undefined} rows={users} />
        </Page>
    );
};

export default UsersPage;
